import {DatePipe} from "@angular/common";
import {Component, inject, OnInit} from '@angular/core';

import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {AdApiService} from "@numizmat/services/core";
import {AdRenewalResponse} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-renewal-history-modal',
  standalone: true,
  imports: [
    DatePipe
  ],
  templateUrl: './renewal-history-modal.component.html',
  styleUrl: './renewal-history-modal.component.scss'
})
export class RenewalHistoryModalComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private adApiService: AdApiService = new AdApiService();

  protected adId!: string;
  protected adTitle!: string;
  protected loading: boolean = true;
  protected renewals: AdRenewalResponse[] = [];

  public ngOnInit(): void {
    this.getAllAdRenewals();
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private getAllAdRenewals(): void {
    this.adApiService.getAllAdRenewals(this.adId).subscribe({
      next: response => {
        this.loading = false;
        this.renewals = response;
      }
    });
  }
}
